import { ImTable } from "react-icons/im";
import { CgCloseO } from "react-icons/cg";
import { VscMenu } from "react-icons/vsc";
import { DiDatabase } from "react-icons/di";
import { ImFileText2 } from "react-icons/im";
import { HiOutlineChat } from "react-icons/hi";
import { RiMailSendLine } from "react-icons/ri";
import { TiSocialGooglePlus } from "react-icons/ti";
import { GiDrippingStar, GiStarsStack } from "react-icons/gi";
import { GoCloudDownload, GoComment, GoCalendar } from "react-icons/go";
import { IoMdNotificationsOutline, IoLogoInstagram } from "react-icons/io";
import { RiBookMarkLine, RiHandCoinLine, RiTwitterLine } from "react-icons/ri";
import { styled } from "@mui/material";
import {
  MdDelete,
  MdTouchApp,
  MdTagFaces,
  MdDarkMode,
  MdLightMode,
  MdAddShoppingCart,
  MdPowerSettingsNew,
} from "react-icons/md";
import {
  BiSupport,
  BiSearch,
  BiEditAlt,
  BiCommentDetail,
} from "react-icons/bi";
import {
  BsFiles,
  BsCheck,
  BsWindow,
  BsPersonPlus,
  BsChevronUp,
  BsChevronDown,
  BsChevronLeft,
  BsChevronRight,
  BsBoxArrowUpRight,
  BsArrowsFullscreen,
  BsReverseLayoutTextWindowReverse,
} from "react-icons/bs";
import {
  IoAppsOutline,
  IoDesktopOutline,
  IoNewspaperOutline,
  IoBagCheckOutline,
  IoSettingsOutline,
  IoCheckmarkCircleOutline,
  IoWarningOutline,
} from "react-icons/io5";
import {
  AiOutlineMail,
  AiOutlineHome,
  AiOutlineFullscreenExit,
  AiOutlineUsergroupAdd,
  AiOutlineLineChart,
  AiOutlineDatabase,
} from "react-icons/ai";
import {
  FaRegWindowRestore,
  FaRegChartBar,
  FaRegMoneyBillAlt,
  FaNetworkWired,
} from "react-icons/fa";
import {
  AiOutlineYoutube,
  AiOutlinePlus,
  AiOutlineHeart,
} from "react-icons/ai";
import {
  FiSend,
  FiLink,
  FiInbox,
  FiCircle,
  FiFacebook,
  FiLinkedin,
} from "react-icons/fi";

const Component = (Icon: any) => {
  return styled(Icon)(() => ({
    fontSize: 18,
  }));
};

const muiIcons = {
  EditIcon: Component(BiEditAlt),
  MenuIcon: Component(VscMenu),
  AppsIcon: Component(IoAppsOutline),
  TableIcon: Component(ImTable),
  PageIcon: Component(BsWindow),
  CircleIcon: Component(FiCircle),
  FacebookIcon: Component(FiFacebook),
  TwitterIcon: Component(RiTwitterLine),
  LinkedinIcon: Component(FiLinkedin),
  LinkIcon: Component(FiLink),
  DarkModeIcon: Component(MdDarkMode),
  LightModeIcon: Component(MdLightMode),
  EmailIcon: Component(AiOutlineMail),
  NetworkIcon: Component(FaNetworkWired),
  YoutubeIcon: Component(AiOutlineYoutube),
  PlusIcon1: Component(AiOutlinePlus),
  InstagramIcon: Component(IoLogoInstagram),
  GoogleIcon: Component(TiSocialGooglePlus),
  SettingIcon: Component(IoSettingsOutline),
  TouchIcon: Component(MdTouchApp),
  SearchIcon: Component(BiSearch),
  DeleteIcon: Component(MdDelete),
  DatabaseIcon: Component(AiOutlineDatabase),
  CommentIcon: Component(GoComment),
  CalendarIcon: Component(GoCalendar),
  CheckMarkIcon: Component(BsCheck),
  UpArrowIcon: Component(BsChevronUp),
  DownArrowIcon: Component(BsChevronDown),
  LeftArrowIcon: Component(BsChevronLeft),
  RightArrowIcon: Component(BsChevronRight),
  CircleCheckMarkIcon: Component(IoCheckmarkCircleOutline),
  PowerIcon1: Component(MdPowerSettingsNew),
  ChartIcon: Component(AiOutlineLineChart),
  ChatIcon: Component(HiOutlineChat),
  WarningIcon: Component(IoWarningOutline),
  CartIcon: Component(MdAddShoppingCart),
  DocsIcon: Component(BsBoxArrowUpRight),
  HeartIcon: Component(AiOutlineHeart),
  DownloadIcon: Component(GoCloudDownload),
  NewsIcon: Component(IoNewspaperOutline),
  AddUserIcon: Component(AiOutlineUsergroupAdd),
  FullScreenIcon: Component(BsArrowsFullscreen),
  ExitScreenIcon: Component(AiOutlineFullscreenExit),
  FormIcon: Component(ImFileText2),
  FaceIcon: Component(MdTagFaces),
  StarIcon: Component(GiDrippingStar),
  StarsIcon: Component(GiStarsStack),
  CloseIcon: Component(CgCloseO),
  InboxIcon: Component(FiInbox),
  Sent2Icon: Component(FiSend),
  SentIcon: Component(RiMailSendLine),
  MoneyIcon: Component(FaRegMoneyBillAlt),
  HomeIcon: Component(AiOutlineHome),
  LibraryIcon: Component(RiBookMarkLine),
  CheckOutIcon: Component(IoBagCheckOutline),
  UiKitIcon: Component(BsFiles),
  DocumentIcon: Component(BiCommentDetail),
  HandCoinIcon: Component(RiHandCoinLine),
  ServerIcon: Component(DiDatabase),
  PersonIcon: Component(BsPersonPlus),
  SupportIcon: Component(BiSupport),
  DashboardIcon: Component(FaRegChartBar),
  DesktopIcon: Component(IoDesktopOutline),
  ExtraKitIcon: Component(BsReverseLayoutTextWindowReverse),
  WidgetsIcon: Component(FaRegWindowRestore),
  NotificationsIcon: Component(IoMdNotificationsOutline),
};

export default muiIcons;
